import { forwardRef } from "react";
import { SVGIconRoot, SVGStrokePath } from "./SVGComponents";
import { IconProps } from "./index";

export const Time = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <SVGIconRoot viewBox="0 0 18 18" ref={ref} {...props}>
      <SVGStrokePath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 3.41L14.59 2L9 7.59L3.41 2L2 3.41L7.59 9L2 14.59L3.41 16L9 10.41L14.59 16L16 14.59L10.41 9L16 3.41Z"
        strokeWidth="2"
      />
    </SVGIconRoot>
  );
});
